export default __webpack_public_path__ + "static/media/float icon3.ff6aff74.png";